import { axiosInstance } from './axiosConfig'; // Cambia la importación
import { handleRequestWithAuth } from './refreshService';

const API_URL = 'userlevels/'; // Usa rutas relativas (el baseURL ya incluye /api/)

// Obtener todos los niveles de usuario
export const fetchUserLevels = async () => {
    return handleRequestWithAuth(async () => {
        const response = await axiosInstance.get(API_URL); // Sin withCredentials
        return response.data;
    });
};

// Crear un nuevo nivel de usuario
export const createUserLevel = async (data: { nombre: string; perfil_asociado: 'cliente' | 'personal'; activo: boolean }) => {
    return handleRequestWithAuth(async () => {
        const response = await axiosInstance.post(API_URL, data); // Incluye el campo perfil_asociado
        return response.data;
    });
};

// Actualizar un nivel de usuario
export const updateUserLevel = async (id: number, data: { nombre: string; perfil_asociado: 'cliente' | 'personal'; activo: boolean }) => {
    return handleRequestWithAuth(async () => {
        const response = await axiosInstance.put(`${API_URL}${id}/`, data); // Incluye el campo perfil_asociado
        return response.data;
    });
};

// Eliminar un nivel de usuario
export const deleteUserLevel = async (id: number) => {
    return handleRequestWithAuth(async () => {
        const response = await axiosInstance.delete(`${API_URL}${id}/`);
        return response.data;
    });
};
